import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Table, message, Spin } from 'antd';
import { _dgidb } from './table_config';
import asyncFetch from '../../utils/asyncFetch';
import { asArray } from '../../utils/dataGuards';

const WithDrug = (props) => {
    let params = useParams();
    return <Drug {...props} params={params} />
}

class Drug extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gene: this.props.params.gene,
            record: [],
            data: [],
            loading: true
        }
    }

    componentDidMount() {
        const { gene } = this.state;
        asyncFetch('GET', '/basic_table/interactions_data', {SYMBOL: gene, current_page: 1, page_size: 10000},
            (res) => {
                if (res.code === 200) {
                    const result = asArray(res.data).map((val, idx) => ({ ...(val || {}), key: idx }));
                    this.setState({
                        record: result,
                        loading: false
                    })
                } else {
                    message.error(res.msg)
                }
            },
        {}, 'cors', {}, false);
    }

    render() {
        const { record } = this.state;
        return (
            <Spin spinning={this.state.loading}>
                <Row>
                    <Col span={24}>
                        <Table
                            scroll={{x: 1200}}
                            columns={_dgidb}
                            dataSource={record}
                        />
                    </Col>
                </Row>
            </Spin>
        )
    }
}

export default WithDrug
